import Swiper from "swiper";
import 'swiper/css/swiper.min.css'

const swiperElements = document.querySelectorAll('.swiper-container-fade')
swiperElements.forEach(swiperElement => {

    // Paramètre par défaut pour les slides
    const defaultParams = {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction : false
        },
        autoHeight: true
    }

    // Récupère les data-attribut sur l'objet déclarant le swiper et créer un objet en fonction du nom des attribut
    const dataParams = Object.assign({}, swiperElement.dataset)
    if(dataParams.breakpoints)
    {
        dataParams.breakpoints = JSON.parse(dataParams.breakpoints)
    }

    /**
     * Déclenchement d'un swipe avec un effet de fade
     * Voir la doc pour la structure HTML de swiper.
     * @type {Swiper}
     */
    const swiperFade = new Swiper('.swiper-container-fade', Object.assign({}, defaultParams, dataParams))
})
